import React from 'react'
import { InputProps } from 'react-admin'

export const UserShowTitle = ({ record }: InputProps) => (
  <span>Пользователь - {record.name}</span>
)
